import React, { Component } from 'react';
import UserContext from '../context/UserContext';
import Config from '../../Config';
import translate from '../i18next/i18next';

import '../../assets/css/agreement.css';

class PrivacyPolicy extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  renderContent = language => {
    const privacyUrl =
      window.trusteInfo !== undefined
        ? window.trusteInfo.privacyUrl
        : 'https://d1rvtd08ngd4ef.cloudfront.net/new+mydlink/privacy_and_tos/privacy_policy_content.html?lang=';
    const iframeLang = language === 'pt' ? 'pt_PT' : language;

    return (
      <div className="page">
        <div className="main_content">
          <div className="agreement_container">
            <div className="agreement_title">
              {translate.t('privacyTitle', { lng: language })}
            </div>
            <div className="terms-container">
              <iframe
                id="privacyFrame"
                src={privacyUrl + iframeLang}
                title="Privacy Policy"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <UserContext.Consumer>
        {({ language }) => this.renderContent(language)}
      </UserContext.Consumer>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/policy/PrivacyPolicy.js